"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialCounterData = void 0;
const IChatData_1 = require("./IChatData");
const IAlertData_1 = require("./IAlertData");
const initialCounterData = () => ({
    message: {
        [IChatData_1.GROUP_TYPE.PRIVATE]: 0,
        [IChatData_1.GROUP_TYPE.NON_PATIENT]: 0,
        [IChatData_1.GROUP_TYPE.PATIENT]: 0,
        [IChatData_1.GROUP_TYPE.BROADCAST]: 0,
        [IChatData_1.GROUP_TYPE.HIDDEN]: 0,
    },
    messageCounter: 0,
    alert: {
        [IAlertData_1.ALERT_TYPE.PRIORITY]: 0,
        [IAlertData_1.ALERT_TYPE.ACKNOWLEDGE]: 0,
        [IAlertData_1.ALERT_TYPE.REFERRAL]: 0,
        [IAlertData_1.ALERT_TYPE.ACKNOWLEDGED]: 0,
        [IAlertData_1.ALERT_TYPE.SENT_ACKNOWLEDGEMENT]: 0,
    },
    alertCounter: 0,
    starredMessageCounter: 0,
});
exports.initialCounterData = initialCounterData;
